(function ($) {
    $(document).ready(function () {
        // TODO uncomment
        return;

        const $carousel = $('.carousel');

        $carousel.swipe({
            swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
                if (direction === 'left') $(this).carousel('next');
                if (direction === 'right') $(this).carousel('prev');
            },
            allowPageScroll: 'vertical'
        });

        $carousel.on('click', function () {
            if ($(window).width() > 576) {
                $(this).carousel('next');
            }
        });
    });
})(jQuery);
